import {
    Component, Log, Modal, CacheStorage,
} from '@WidgetWorks';
import Swiper from 'swiper/bundle';
// import Cropper from 'cropperjs';
// import 'cropperjs/dist/cropper.css';

export default class RecommendationWindow extends Component {
    constructor(appConfig) {
        super(appConfig);
        this.interacted = false;
        this.swiper = null;
    }

    overrideHook() {
        return true;
    }

    preRenderHook() {
    }

    beforeMountHook() {
        // Handlers
        this.root = this.element.shadowRoot.querySelector('section');

        // Add in the logo
        if (this.resources.logo) {
            // const logoPoint = this.root.querySelector('#header-customer-logo');
            // logoPoint.src = this.resources.logo;
        }

        // Add the listeners for the langs selector
        this.addEventListenerForDropDown();
        this.updateLanguageDropdown();

        // Assuming background is a child element of this.root
        // And if the close button id is present too
        // const background = this.root.querySelector('.background');
        const closeElements = this.root.querySelectorAll('[close]');

        closeElements.forEach((elm) => {
            elm.addEventListener('click', (event) => {
                event.stopPropagation();
                // Check if the click target is the background (not the floating window)
                if (event.target === elm && event.target.id !== 'image_upload_button') {
                    // Close the window by calling the toggleDisplay method of the class
                    this.toggleDisplay();
                }
            });
        });

        // !! Very silly demo logic.
        let demoMode = null;

        // If demo mode 2
        const internalId = this.appFactory.productId.slice(0, -3);
        if (internalId === '2229A') {
            this.root.querySelectorAll('.demo2').forEach((demo) => {
                demo.style.display = 'block';
            });

            demoMode = true;
        }

        // demo mode 3
        if (internalId === '2368A') {
            this.root.querySelectorAll('.demo3').forEach((demo) => {
                demo.style.display = 'block';
            });

            demoMode = true;
        }

        // If no argument are passed, we're demo1.
        if (!demoMode) {
            this.root.querySelectorAll('.demo1').forEach((demo) => {
                demo.style.display = 'block';
            });
        }

        // Setup the slider
        this.initSwiper();
    }

    initSwiper() {
        const swiperEl = this.root.querySelector('.swiper');
        const nextEl = this.root.querySelector('.swiper-button-next');
        const prevEl = this.root.querySelector('.swiper-button-prev');
        // const paginationEl = this.root.querySelector('.swiper-pagination');

        this.swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            navigation: {
                nextEl,
                prevEl,
            },
            breakpoints: {
                768: {
                    slidesPerView: 5,
                },
            },
        });
    }

    addEventListenerForDropDown() {
        const languageDropdown = this.root.querySelector('[language-dropdown-button]');
        const dropdownContent = this.root.querySelector('[language-dropdown]');

        // Run language change event
        const languageElements = this.root.querySelectorAll('[language]');
        languageElements.forEach((lang) => {
            lang.addEventListener('click', (event) => {
                const { target } = event;
                const langCode = target.getAttribute('language');
                this.changeLanguage(langCode);
            });
        });

        // Auto open the widget if button is clicked
        languageDropdown.addEventListener('click', () => {
            this.openLanguageDropdown();
        });

        // auto closer
        this.root.addEventListener('click', (event) => {
            const { target } = event;
            if (target === languageDropdown || target === dropdownContent) return;
            if (!dropdownContent.contains(target) && !languageDropdown.contains(target)) {
                this.closeLanguageDropdown();
            }
        });
    }

    updateLanguageDropdown() {
        const languageDropdown = this.root.querySelector('[language-dropdown-button]');
        const langCode = this.productPageInfo.languageCode;
        languageDropdown.setAttribute('setLang', langCode);

        //  Automatically hide the language from the dropdown
        const allDefaultLangs = this.root.querySelectorAll(`[language=${langCode}]`);
        allDefaultLangs.forEach((lang) => {
            const langElement = lang;
            langElement.style.display = 'none';
        });
    }

    openLanguageDropdown() {
        const dropDown = this.root.querySelector('[language-dropdown]');
        dropDown.style.display = 'flex';
    }

    closeLanguageDropdown() {
        const dropDown = this.root.querySelector('[language-dropdown]');
        dropDown.style.display = 'none';
    }

    async changeLanguage(lang) {
        // Change the language of the app.
        this.root.setAttribute('language', lang);

        // Restart the language dropdown
        this.root.querySelectorAll('[language]').forEach((langElement) => {
            const element = langElement;
            element.style.display = 'flex';
        });

        // hide the new language from the dropdown
        const allLangs = this.root.querySelectorAll(`[language=${lang}]`);
        allLangs.forEach((langElement) => {
            const element = langElement;
            element.style.display = 'none';
        });

        // Craft url
        const url = `./content/langs/${lang}.json`;

        // Get the new language
        const newLang = await this.appFactory.loadAllPromises([url]);
        this.language = JSON.parse(newLang);

        // do the same on the children and the current.
        this.insertLanguages(this.language);
        this.uploadButton.updateLanguagesForAllCopies(this.language);
        return true;
    }

    errorPage(header = 'Error Occurred', message = 'An unknown error has occurred, please try again later') {
        this.modal = new Modal(this.root, header, message, this.language.upload_button_app.modal);
        this.modal.display();
    }

    postRenderHook() {
        return true;
    }

    uploadResponseAnalytics() {

    }

    firstInteractionHook() {
        if (this.interacted) return false;
        this.interacted = true;
        return true;
    }

    async mountElement() {
        let counter = 0;

        if (this.mountPoints.length > 1) {
            console.log(...Log.w('SizeViewRecommendationWindow', 'WARN', 'App is singleton, only one point will be mounted'));
        }

        try {
            const point = this.mountPoints[0];
            const mountPoint = this.mountPoints[0].mount_points[0];
            await this.waitForElementToExist(mountPoint);
            const targetElement = document.querySelector(mountPoint);
            if (targetElement) {
                targetElement.appendChild(this.element);
            }

            // Insert attributes into the new elements
            this.root.setAttribute('mountId', point.mount_id);
            point.attributes.forEach((attr) => {
                this.root.setAttribute(attr, '');
            });

            this.root.setAttribute('mountPointIndex', counter);
            this.root.setAttribute('language', this.productPageInfo.languageCode);

            counter += 1;
        } catch (error) {
            console.warn(`Could not mount this element correctly ${error}`);
            console.log(...Log.w('SizeViewRecommendationWindow', 'ERROR', `Could not mount this element: ${error}`));
        }
        console.log(...Log.w('SizeViewRecommendationWindow', 'LOG', `Mounted ${counter} elements (Max 1)`));
        return true;
    }

    async init() {
        console.log(...Log.w('SizeViewRecommendationWindow', 'LOG', 'Initialising...'));

        // This hook will run the custom function defined in the override itself.
        this.overrideHook();

        // Before rendering, do these things.
        this.preRenderHook();

        // Insert CSS into virtual element
        this.insertCSS(this.styles);

        // Insert HTML into virtual element
        this.insertHTML(this.markup);

        // Update HTML with Languages into the virtual element
        this.insertLanguages(this.language);

        // Run the pre mounted hook.
        this.beforeMountHook();

        // Once the mount point is available, mount it.
        // This is a singular mount, not copies.
        await this.mountElement();

        // Now mounted, run the post hooks
        this.postRenderHook();

        console.log(...Log.w('SizeViewRecommendationWindow', 'LOG', 'Initialised'));
    }

    async recommendationsController(productId) {
    }

    insertFilters() {
    }

    sortRecommendations(sortBy) {

    }

    insertLanguages(langs) {
        // Dynamic insertion using a recursive post order
        // technique is the default function to insertion of languages
        // feel free to override.
        this.recursiveLanguageInsertion(langs, '');
        return true;
    }

    async getRecommendationsApi(productId) {

    }

    setupCropperButton() {

    }

    /* The above code is defining a function called "renderMainProduct" in JavaScript. */
    renderMainProduct(currentProduct, productPoint) {

    }

    // async cropImage() {
    //     const result = this.cropper.getCroppedCanvas().toDataURL('image/jpeg');
    //     const file = this.dataURLtoFile(result, 'croppedImage.jpg');
    //     await this.uploadButton.uploadPicture(file);
    // }

    // initialiseCropper() {
    //     const image = this.root.querySelector('#main-product-img');
    //     this.cropper = null;
    //     this.cropper = new Cropper(image, {
    //         viewMode: 1,
    //         zoomOnTouch: false,
    //         zoomOnWheel: false,
    //         zoomable: false,
    //         toggleDragModeOnDblclick: false,
    //         crop(event) {
    //             console.log(event.detail.x);
    //             console.log(event.detail.y);
    //             console.log(event.detail.width);
    //             console.log(event.detail.height);
    //             console.log(event.detail.rotate);
    //             console.log(event.detail.scaleX);
    //             console.log(event.detail.scaleY);
    //         },
    //     });
    // }

    syncGenderFilter() {

    }

    // TODO: CREATE DEFAULT VALUES
    renderRecommendations(recommendations, insertionPoint, titleToShow = 'title') {

    }

    registerImageErrorHandlers(recommendations) {

    }

    registerProductRedirects(recommendations) {

    }

    loadClickedProducts() {

    }

    saveClickedProducts() {

    }

    placeProductIntoLocalStorage(productDetails) {

    }

    async openProduct(productDetails) {

    }

    showElement(elementId) {
        const element = this.root.querySelector(elementId);
        if (element) {
            element.style.display = 'block'; // Replace with the desired display value
        }
    }

    hideElement(elementId, delay = 0) {
        const element = this.root.querySelector(elementId);

        if (element) {
            setTimeout(() => {
                element.style.display = 'none';
            }, delay);
        }
    }

    productObserver() {

    }

    toggleLoading() {
        const loader = this.root.querySelector('#loader');
        if (loader.style.display === 'none') {
            loader.style.display = 'block'; // Replace with the desired display value
        } else {
            loader.style.display = 'none';
            // setTimeout(() => {
            // }, 500);
        }
    }

    connectionDisplayApp() {
        // This function is the first point of interaction from the user.
        // So we call the first pointer of interaction hook. In case it has anything for it to do.
        this.firstInteractionHook();

        this.toggleDisplay();
    }

    anim() {
        if (this.root.style.display === 'none') {
            this.root.classList.remove('hidden');
            this.root.style.display = 'block';
            // Trigger a reflow to apply the initial style before adding the visuallyhidden class
            this.root.offsetHeight;
            this.root.classList.remove('visuallyhidden');
        } else {
            this.root.classList.add('visuallyhidden');

            // Delay the hiding to ensure the animation is visible
            setTimeout(() => {
                this.root.style.display = 'none';
                this.root.classList.add('hidden');
            }, 600); // Adjust the delay as needed to match your transition duration
        }
    }

    runInAnim() {
        this.root.style.display = 'block';
        this.root.style.opacity = 1;
    }

    runOutAnim() {
        this.root.style.transition = 'opacity 500ms ease-out';
        this.root.style.opacity = 0;
        setTimeout(() => {
            this.root.style.display = 'none';
        }, 500);
    }

    toggleDisplay() {
        if (this.root.style.display === 'none') {
            this.anim();
        } else {
            this.anim();
        }
    }
}
